<template>
  <div class="fm-grid-view">
    <div class="fm-grid-view__container" @click.self="$emit('voidClick', $event)">
      <FileCard
        v-for="file in displayedFiles"
        :key="file.id"
        :file="file"
        :selected="selected.includes(file.id)"
        @click="$emit('fileClick', $event)"
        @doubleClick="$emit('fileDoubleClick', $event)"
      />
    </div>
    <div v-if="files.length > displayRange" class="fm-grid-view__load-button">
      <button class="action-btn" @click="loadMore">{{ $t('message.LOAD_MORE') }}</button>
    </div>
  </div>
</template>

<script>
/**
 * Grid view layout for FileManager component
 *
 * @vue-prop {Object[]} files - List of file informations
 * @vue-prop {Number[]} [selected] - List of file IDs selected
 * @vue-event {Object} fileClick - Triggered when file chip is clicked
 * @vue-event {Object} fileDoubleClick - Triggered when file chip is double clicked
 */
import FileCard from './file-card.vue';

const FILES_INC_NUMBER = 20;

export default {
  name: 'FileManagerGridView',

  components: {
    FileCard,
  },

  props: {
    files: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
      validator: a => a.every(v => typeof v === 'number' && v > 0),
    },
  },

  data() {
    return {
      displayRange: FILES_INC_NUMBER,
    };
  },

  computed: {
    displayedFiles() {
      return this.files.slice(0, this.displayRange);
    },
  },

  methods: {
    /** Add more items to load */
    loadMore() {
      this.displayRange += FILES_INC_NUMBER;
    },
  },
};
</script>

<style lang="scss">
.fm-grid-view {
  margin-bottom: 10em;

  &__container {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
    height: 100%;
    width: 100%;
  }

  &__load-button {
    width: 100%;
    text-align: center;
    margin-top: 1em;
  }
}
</style>
